<template>
  <div class="table-pivot-config">
    <div v-if="internalPivotConfig" class="groups">
      <pivot-config-group
        v-model="internalPivotConfig"
        :options="flatDimensionsOptions"
        :metas="dimensionMetas"
        role="rows"
      />
      <pivot-config-group
        v-model="internalPivotConfig"
        :options="flatDimensionsOptions"
        :metas="dimensionMetas"
        role="columns"
      />
      <pivot-config-group
        v-model="internalPivotConfig"
        :options="flatDimensionsOptions"
        :metas="dimensionMetas"
        role="filters"
      />
    </div>
  </div>
</template>

<script>
import PivotConfigGroup from './PivotConfigGroup.vue'
export default {
  components: { PivotConfigGroup },
  model: {
    prop: 'pivotConfig',
    event: 'change',
  },
  props: ['pivotConfig', 'flatDimensionsOptions', 'dimensionMetas'],
  data() {
    return {
      internalPivotConfig: null,
    }
  },
  watch: {
    pivotConfig: {
      handler(value) {
        this.internalPivotConfig = value
      },
      immediate: true,
    },
    internalPivotConfig: {
      handler(value) {
        if (JSON.stringify(value) !== JSON.stringify(this.pivotConfig)) {
          this.$emit('change', value)
        }
      },
      deep: true,
    },
  },
}
</script>

<style lang="stylus" scoped></style>
